import { DesignToken as e } from "@matrix42/fast-foundation";
import { colorRange as h } from "./theme/tokens/color-range.js";
import { spacings as i } from "./theme/tokens/spacings.js";
function t(a) {
  const r = {};
  for (const o of h)
    r[o] = e.create(`${a}-${o}`);
  return r;
}
const c = () => {
  const a = {};
  for (const r of i)
    a[r] = e.create(
      `spacing-${r.toString().replace(".", "-")}`
    );
  return a;
}, d = {
  color: {
    primary: t("primary"),
    secondary: t("secondary"),
    neutral: t("neutral"),
    success: t("success"),
    warning: t("warning"),
    error: t("error"),
    black: e.create("black"),
    white: e.create("white"),
    overlay: e.create("overlay"),
    ai: {
      purple: e.create("ai-purple"),
      teal: e.create("ai-teal")
    }
  },
  fontFamily: {
    sans: e.create("font-family-sans"),
    mono: e.create("font-family-mono")
  },
  fontSize: {
    label: e.create("font-size-label"),
    p: e.create("font-size-p"),
    h6: e.create("font-size-h6"),
    h5: e.create("font-size-h5"),
    h4: e.create("font-size-h4"),
    h3: e.create("font-size-h3"),
    h2: e.create("font-size-h2"),
    h1: e.create("font-size-h1"),
    "h1-xl": e.create("font-size-h1-xl"),
    "h1-2xl": e.create("font-size-h1-2xl"),
    "h1-3xl": e.create("font-size-h1-3xl"),
    code: e.create("font-size-code")
  },
  lineHeight: {
    label: e.create("line-height-label"),
    p: e.create("line-height-p"),
    h6: e.create("line-height-h6"),
    h5: e.create("line-height-h5"),
    h4: e.create("line-height-h4"),
    h3: e.create("line-height-h3"),
    h2: e.create("line-height-h2"),
    h1: e.create("line-height-h1"),
    "h1-xl": e.create("line-height-h1-xl"),
    "h1-2xl": e.create("line-height-h1-2xl"),
    "h1-3xl": e.create("line-height-h1-3xl"),
    code: e.create("line-height-code")
  },
  fontWeight: {
    label: e.create("font-weight-label"),
    p: e.create("font-weight-p"),
    h6: e.create("font-weight-h6"),
    h5: e.create("font-weight-h5"),
    h4: e.create("font-weight-h4"),
    h3: e.create("font-weight-h3"),
    h2: e.create("font-weight-h2"),
    h1: e.create("font-weight-h1"),
    "h1-xl": e.create("font-weight-h1-xl"),
    "h1-2xl": e.create("font-weight-h1-2xl"),
    "h1-3xl": e.create("font-weight-h1-3xl"),
    regular: e.create("font-weight-regular"),
    semibold: e.create("font-weight-semibold"),
    bold: e.create("font-weight-bold"),
    code: e.create("font-weight-code")
  },
  //TODO implement in tailwind preset
  transition: {
    fast: e.create("transition-fast")
  },
  shadow: {
    box: {
      xs: e.create("box-shadow-xs"),
      sm: e.create("box-shadow-sm"),
      md: e.create("box-shadow-md"),
      lg: e.create("box-shadow-lg"),
      xl: e.create("box-shadow-xl")
    },
    drop: {
      xs: e.create("drop-shadow-xs"),
      sm: e.create("drop-shadow-sm"),
      md: e.create("drop-shadow-md"),
      lg: e.create("drop-shadow-lg"),
      xl: e.create("drop-shadow-xl")
    }
  },
  borderWidth: {
    xs: e.create("border-width-xs"),
    sm: e.create("border-width-sm")
  },
  borderRadius: {
    xs: e.create("border-radius-xs"),
    sm: e.create("border-radius-sm"),
    md: e.create("border-radius-md"),
    lg: e.create("border-radius-lg"),
    xl: e.create("border-radius-xl"),
    full: "9999px"
  },
  iconSize: {
    xs: e.create("icon-size-xs"),
    sm: e.create("icon-size-sm"),
    md: e.create("icon-size-md")
  },
  spacing: c(),
  htmlFontSize: e.create("html-font-size")
};
export {
  d as designTokens
};
